/**
 * This file is a part of Amblique's projects.
 *
 * Copyright © Amblique - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

/**
 * Car Explorer options container
 *
 * @link [Sirv Media Viewer](https://sirv.com/help/articles/sirv-media-viewer/)
 * @link [Pannellum](https://pannellum.org/)
 */
export const carExplorerOptions = {
  /**
   * Default options - always applied
   */
  default: {
    views: {
      exterior: {
        static: [],
        spin: []
      },
      interior: {
        static: [],
        panorama: []
      },
      boot: {
        static: [],
        spin: []
      }
    }
  },

  configurator: {
    /**
     * Open 360 on load and on each grade or colour change when the variant has it.
     * A colour change keeps static if the shopper turned 360 off for this grade.
     */
    defaultMode: '360',
    views: {
      exterior: {
        static: ['day', 'night'],
        spin: ['day', 'night']
      },
      interior: {
        static: ['day', 'night'],
        panorama: ['day', 'night']
      },
      boot: {
        static: ['day'],
        spin: []
      }
    }
  },

  showroom: {
    views: {
      exterior: {
        static: [],
        spin: ['day', 'night']
      },
      interior: {
        static: [],
        panorama: ['day', 'night']
      },
      boot: {
        static: ['day', 'night'],
        spin: []
      }
    }
  }
};
